import { render, staticRenderFns } from "./CheckCustomerHistory.vue?vue&type=template&id=259b360a&scoped=true&"
import script from "./CheckCustomerHistory.vue?vue&type=script&lang=ts&"
export * from "./CheckCustomerHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259b360a",
  null
  
)

export default component.exports